import { combineReducers } from 'redux';

import {
  getListsRequest,
  getListsSuccess,
  getListsFail,
} from '../actions';
import { Reducer } from '../../../types';
import { ListsAction, StateLists } from '../types';


type ReducerOf<T extends keyof StateLists> = Reducer<StateLists, ListsAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getListsRequest.type:
      return state ? state : null;

    case getListsSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getListsRequest.type:
      return true;

    case getListsSuccess.type:
    case getListsFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateLists>({
  data,
  loading,
});
